export const shoppingMixins = {
    computed: {
        cartCount() {
            return this.$store.getters.getCartCount;
        },
        getSubtotalPrice() {
            return this.$store.getters.getSubtotalPrice
        },
        getTotalPrice() {
            this.totalPrice = this.$store.getters.getTotalPrice;
            return this.totalPrice;
        },
        cartApiError() {
            return this.$store.getters.getCartApiError;
        },
        pendingOrdersCount() {
            return this.$store.getters.getPendingOrdersCount;
        },
        pendingDogOrdersCount() {
            return this.$store.getters.getPendingDogOrdersCount;
        },
        transactionApiError() {
            return this.$store.getters.getTransactionApiError;
        },
        purchaseCartCount() {
            return this.$store.getters.getPurchaseCartCount;
        },
        purchaseBundleId() {
            return this.$store.getters.getPurchaseBundleId;
        },
        isItemDeactivated() {
            return this.$store.getters.getIsProductDeactivated;
        },
        isItemOutOfStock() {
            return this.$store.getters.getIsProductOutOfStock;
        },
        isCartCheckoutEnabled() {
            return this.$store.getters.getIsCheckoutEnabled;
        },
    },
    watch: {
        cartApiError(cart) {
            if (cart) {
                this.showAPIErrorToast(cart.message, cart.res);
            }
        },
        transactionApiError(newVal) {
            if (newVal) {
                this.showAPIErrorToast(newVal.message, newVal.res);
            }
        },
    },
    methods: {
        showCart(queryParams) {
            let url = '/products/cart';
            if (typeof queryParams === 'string' && queryParams.trim() !== '') {
                //Apend the query param
                url += `?from=${queryParams}`;
            }
            this.$router.push(url);
        },
        setCartCount(petId) {
            this.$store.dispatch("setCartCount", petId);
        },
        getImage(list) {
            if (list.isCustomBundle) {
                return list.imageUrl ? list.imageUrl : require("@/assets/images/product/product-default.png");
            } else {
                return list.products[0].imageUrl
                    ? list.products[0].imageUrl
                    : require("@/assets/images/product/product-default.png");
            }
        },
        setPendingOrderCount(petId) {
            this.$store.dispatch("setPendingOrderCount", petId);
        },
        setPendingDogOrderCount() {
            this.$store.dispatch("setPendingDogOrderCount");
        },

        checkProductDeactivated(cart) {
            let deactivated = false;

            // Check for single product
            if (!cart.isCustomBundle) {
                for (const key in cart.products) {
                    const product = cart.products[key];
                    if (product.status === "I" || product.status === "D") {
                        deactivated = true;
                    }
                }
            } else {
                deactivated = cart.bundleStatus === "I" || cart.bundleStatus === "D";
            }

            return deactivated;
        },

        checkProductOutOfStock(cart) {
            if (!cart || !cart.products) return false;

            for (const key in cart.products) {
                const product = cart.products[key];
                
                if (cart.isCustomBundle) {
                    return false;
                }
                    
                // Check if product have stocks available
                else if (product.productInventory.stockQty <= 0 || !product.productInventory.stockQty) {
                    return true;
                }
            }

            return false;
        },

        checkBundleLowOnStock(cart) {

            let productLowOnStockList = [];
            cart.forEach(bundle => {
                bundle.products.forEach(product => {
                    let checkStockAvailable = product.productInventory.stockQty && product.productInventory.stockQty < product.productInventory.minStock;
                    if (checkStockAvailable && product.productInventory.stockQty >= 0) {
                        productLowOnStockList.push(bundle);
                    }
                });
            });

            return productLowOnStockList;
        },

        checkBundleOutOfStock(cart) {

            let productOutOfStockList = [];

            cart.forEach(bundle => {
                bundle.products.forEach(product => {
                    if (product.productInventory.stockQty <= 0 || !product.productInventory.stockQty) {
                        productOutOfStockList.push(bundle);
                    }
                });
            });

            return productOutOfStockList;
        },
    },
};
